/**
 * Collect HealthKit activities from weekly report healthData snapshots.
 * Weekly reports store daily health under report.healthData[].reportData.activities.
 */
export function collectWeeklyReportActivities(report) {
  if (!report?.healthData?.length) return [];

  const rows = [];
  for (const day of report.healthData) {
    const dayActs = day.reportData?.activities;
    if (!Array.isArray(dayActs) || dayActs.length === 0) continue;

    for (const activity of dayActs) {
      rows.push({
        ...activity,
        dateIndex: day.dateIndex,
        dayCreatedOn: day.createdOn,
      });
    }
  }

  return rows.sort((a, b) => {
    const aTime = a.startDate
      ? new Date(a.startDate).getTime()
      : a.dayCreatedOn?.seconds
        ? a.dayCreatedOn.seconds * 1000
        : 0;
    const bTime = b.startDate
      ? new Date(b.startDate).getTime()
      : b.dayCreatedOn?.seconds
        ? b.dayCreatedOn.seconds * 1000
        : 0;
    return bTime - aTime;
  });
}

export function weeklyReportHasActivities(report) {
  return collectWeeklyReportActivities(report).length > 0;
}
